import { withSacredImages } from "../utils/image-urls";

/** @type {Array<{id:string,name:string,beginner:Object,deep:Object}>} */
const VRATAS_RAW = [
  {
    id: "ekadashi",
    name: "Ekādaśī vrata",
    beginner: {
      meaning: "Eleventh tithi dedicated to Viṣṇu — fasting and nāma.",
      simple_rules: ["No grains on Ekādaśī", "Break fast after sunrise on dvādaśī", "Chant Viṣṇu nāma"],
      key_mantra: "ॐ नमो नारायणाय",
    },
    deep: {
      timings: ["Begin at sunrise Ekādaśī", "Break fast dvādaśī after sunrise with parana time per calendar"],
      food_guidelines: ["Avoid rice, wheat, lentils on strict vow", "Fruits, milk, roots per lineage"],
      full_rules: ["Bathe before sunrise", "Avoid anger and lies", "Night vigil optional"],
      sadhana: ["Viṣṇu Sahasranāma", "Read Ekādaśī mahātmya"],
      mantras: ["Nārāyaṇa", "Daśākṣarī"],
      benefits: ["Purifies mind", "Tradition links to liberation of ancestors in some stories"],
      scriptural_refs: ["Padma Purāṇa", "Bhāgavata Ekādaśī tales"],
    },
  },
  {
    id: "pradosham",
    name: "Pradoṣa / Pradoṣham",
    beginner: {
      meaning: "Twilight worship of Śiva on trayodaśī.",
      simple_rules: ["Visit Śiva temple or home liṅga at dusk", "Abhiṣeka if possible", "Chant Śiva nāma"],
      key_mantra: "ॐ नमः शिवाय",
    },
    deep: {
      timings: ["Approx. 90 minutes around sunset on śukla/kṛṣṇa trayodaśī"],
      food_guidelines: ["Light fast till pradosha pūjā in strict traditions"],
      full_rules: ["Bilva offering valued", "Circumambulation of temple"],
      sadhana: ["Rudram or pañcākṣarī", "Silence after pūjā"],
      mantras: ["Mahāmṛtyuñjaya", "Pañcākṣarī"],
      benefits: ["Removes obstacles", "Śiva's grace at sandhyā"],
      scriptural_refs: ["Śiva Purāṇa Pradoṣa mahātmya"],
    },
  },
  {
    id: "sankashti",
    name: "Sankṣaṣṭi / Sankastahara Chaturthi",
    beginner: {
      meaning: "Gaṇeśa vrata on kṛṣṇa chaturthi — removes difficulties.",
      simple_rules: ["Fast till moonrise or evening pūjā", "Offer modaka", "Read Gaṇeśa stuti"],
      key_mantra: "ॐ गं गणपतये नमः",
    },
    deep: {
      timings: ["Kṛṣṇa pakṣa chaturthi; moon sighting ends fast in many homes"],
      food_guidelines: ["Fast till moonrise", "Modaka as prasāda"],
      full_rules: ["Gaṇeśa Atharvaśīrṣa optional", "Charity after pūjā"],
      sadhana: ["21 chaturthi cycle for major sankalpa"],
      mantras: ["Vakratunda stotra", "Gaṇeśa mantra"],
      benefits: ["Vighna removal", "Fulfillment of ethical wishes"],
      scriptural_refs: ["Gaṇeśa Purāṇa", "Sankastahara chaturthi vrata katha"],
    },
  },
  {
    id: "purnima",
    name: "Pūrṇimā observances",
    beginner: {
      meaning: "Full moon — completion, Satyanārāyaṇa, and Devi pūjā.",
      simple_rules: ["Evening lamp", "Satyanārāyaṇa or pūrṇimā pūjā if vowed", "Charity"],
      key_mantra: "ॐ श्रीं नमः",
    },
    deep: {
      timings: ["Moonrise evening; some fast daytime only"],
      food_guidelines: ["Satyanārāyaṇa feast after kathā", "Some observe upavāsa till moon"],
      full_rules: ["Tell Satyanārāyaṇa story completely if doing vrata", "Invite guests for prasāda"],
      sadhana: ["Gratitude meditation under moon", "Anna-dāna"],
      mantras: ["Satyanārāyaṇa stotram", "Devi stuti on Kojagiri traditions"],
      benefits: ["Completeness of endeavors", "Family harmony"],
      scriptural_refs: ["Skanda Purāṇa Satyanārāyaṇa", "Devi pūrṇimā traditions"],
    },
  },
  {
    id: "amavasya",
    name: "Amāvasyā / Pitṛ remembrance",
    beginner: {
      meaning: "New moon — honoring ancestors and inner reset.",
      simple_rules: ["Tarpaṇa if father/elder tradition applies", "Simple sattvic food", "Charity"],
      key_mantra: "ॐ पितृ देवाय नमः",
    },
    deep: {
      timings: ["Morning tarpana common; Mahālaya season intensified"],
      food_guidelines: ["Many avoid elaborate feasting", "Soma piṇḍa traditions per śāstra"],
      full_rules: ["Respect elders", "Visit holy waters if possible"],
      sadhana: ["Silent reflection on lineage", "Forgive ancestors' human flaws"],
      mantras: ["Pitṛ tarpana mantras with teacher", "Mahāmṛtyuñjaya for ancestors"],
      benefits: ["Ancestral peace", "Inner grounding"],
      scriptural_refs: ["Garuḍa Purāṇa pretakanda", "Dharma śāstra on śrāddha"],
    },
  },
  {
    id: "monthly_shivaratri",
    name: "Monthly Śivarātri",
    beginner: {
      meaning: "Kṛṣṇa pakṣa chaturdaśī night of Śiva each month.",
      simple_rules: ["Light lamp at night", "Pañcākṣarī japa", "Bilva if available"],
      key_mantra: "ॐ नमः शिवाय",
    },
    deep: {
      timings: ["Night of kṛṣṇa chaturdaśī each lunar month"],
      food_guidelines: ["Optional fast with milk/fruits"],
      full_rules: ["Four praharas simplified to one vigil for householders"],
      sadhana: ["Monthly discipline builds toward Mahāśivarātri"],
      mantras: ["Rudram monthly if trained", "Pañcākṣarī 108×"],
      benefits: ["Steady śiva-bhakti", "Reduces rajas"],
      scriptural_refs: ["Śiva Purāṇa"],
    },
  },
];

export const VRATAS = withSacredImages("vratas", VRATAS_RAW);

export function getVrata(id) {
  return VRATAS.find((v) => v.id === id) ?? null;
}
